module.exports = __webpack_public_path__ + "static/9-a34cc7be32c79a48afee2a2f2d2c5c78.jpg";